import React from 'react';
import PropTypes from 'prop-types';

import { Wrapper, Container, Name, ContentWrapper, Title, Hr, NameSuffix } from './Hero.style';
import Placeholder from '../../../../components/Placeholder';

const Hero = ({ user, copy }) => (
  <Wrapper>
    <Container>
      <Title>{copy.your_hair_profile || <Placeholder w="200px" h="20px" />}</Title>
      <Hr />
      <ContentWrapper>
        <Name>
          {user.name || <Placeholder w="100%" h="16px" />}
          {user.name && copy.diagnonsis_name && <NameSuffix>{copy.diagnonsis_name}</NameSuffix>}
        </Name>
      </ContentWrapper>
    </Container>
  </Wrapper>
);

Hero.defaultProps = {
  copy: {
    your_hair_profile: 'Your hair profile',
  },
};

Hero.propTypes = {
  user: PropTypes.shape({
    name: PropTypes.string,
    country: PropTypes.string,
    hairLength: PropTypes.string,
    hairType: PropTypes.string,
  }).isRequired,
  copy: PropTypes.shape({
    your_hair_profile: PropTypes.string,
  }),
};

export default Hero;



// WEBPACK FOOTER //
// ./src/pages/HairDiagnosis/HairDiagnosisResultPage/Hero/Hero.js